export const GET_JOBS_APPLICATIONS = 'GET_JOBS_APPLICATIONS';
